import React, { ReactElement, ReactNode } from 'react';
import { ModeleHoraireActivite } from '../../../../../common/src/entities/modele-horaire-activite.entity';
import { ArrayHelpers } from 'formik';
import { Col, Row } from 'react-bootstrap';
import { BiCheckCircle } from 'react-icons/bi';
import ChampMultipleDnd from '../Thematiques/ChampMultipleDnd';
import { ModeleHoraireProduit } from '../../../../../common/src/entities/modele-horaire-produit.entity';
import { LinkWithTooltip } from '../../Common/LinkWithTooltip';

const AffichageElement = (props: {
    value: ModeleHoraireActivite | ModeleHoraireProduit;
    index: number;
    helpers: ArrayHelpers;
    affichageTexte: (value: ModeleHoraireActivite | ModeleHoraireProduit) => ReactNode;
    horaireParDefautId: number;
}): ReactElement => {
    const { value, affichageTexte, horaireParDefautId } = props;
    const isHoraireParDefaut = horaireParDefautId === value.modeleHoraire.id;

    return (
        <Row className="py-2">
            <Col className="d-flex align-items-center ml-2">
                <span>
                    <label>{affichageTexte(value)} </label>{' '}
                    {isHoraireParDefaut && (
                        <LinkWithTooltip
                            tooltip="Horaire par défaut"
                            id={`tooltip-horaire-par-defaut-${value.modeleHoraire.id}`}
                            href="#"
                        >
                            <BiCheckCircle size="1.25em" />
                        </LinkWithTooltip>
                    )}
                </span>
            </Col>
        </Row>
    );
};

const affichageElement = (
    value: ModeleHoraireActivite | ModeleHoraireProduit,
    index: number,
    helpers: ArrayHelpers,
    affichageTexte: (value: ModeleHoraireActivite | ModeleHoraireProduit) => ReactNode,
    horaireParDefautId: number,
) => <AffichageElement {...{ value, index, helpers, affichageTexte, horaireParDefautId }} />;

interface PropsChampMultipleModelesHoraireGlissable {
    id: string;
    labelCol?: number;
    horaireParDefautId: number;
}

export default function ChampMultipleModelesHoraireGlissable(
    props: PropsChampMultipleModelesHoraireGlissable,
): ReactElement {
    return (
        <ChampMultipleDnd
            entite={ModeleHoraireActivite}
            titre="Modèles d'horaire"
            {...props}
            affichageTexte={(value: ModeleHoraireActivite | ModeleHoraireProduit | number) => (
                <>{(value as ModeleHoraireActivite | ModeleHoraireProduit).modeleHoraire.name}</>
            )}
            affichageElement={(
                value: ModeleHoraireActivite | ModeleHoraireProduit | number,
                index: number,
                helpers: ArrayHelpers,
                affichageTexte: (value: ModeleHoraireActivite | ModeleHoraireProduit) => ReactNode,
            ) =>
                affichageElement(
                    value as ModeleHoraireActivite | ModeleHoraireProduit,
                    index,
                    helpers,
                    affichageTexte,
                    props.horaireParDefautId,
                )
            }
            labelCol={props.labelCol}
        />
    );
}
